"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMode = exports["default"] = void 0;
require("core-js/modules/es.date.to-string.js");
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rmcDatePicker = _interopRequireDefault(require("rmc-date-picker"));
var _Popup = _interopRequireDefault(require("rmc-date-picker/lib/Popup"));
require("rmc-picker/assets/index.css");
require("rmc-date-picker/assets/index.css");
require("rmc-picker/assets/popup.css");
var _formElements = require("@evidation/form-elements");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _dateFns = require("date-fns");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Input = (0, _styledComponents["default"])(_formElements.TextInput).withConfig({
  displayName: "mobile__Input"
})(["cursor:pointer;&:disabled{cursor:default;}"]);
var getMode = exports.getMode = function getMode(format) {
  switch (format) {
    case 'YYYY-MM':
      return 'month';
    case 'YYYY':
      return 'year';
    case 'MM-DD-YYYY':
    case 'YYYY-MM-DD':
    default:
      return 'date';
  }
};
var DOB = function DOB(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    formatDisplay = _ref.formatDisplay,
    formatSubmit = _ref.formatSubmit,
    parseValue = _ref.parseValue,
    placeholder = _ref.placeholder,
    dateFormat = _ref.dateFormat,
    disabled = _ref.disabled;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(value ? parseValue(value) : undefined),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    date = _useState4[0],
    setDate = _useState4[1];
  var datePicker = /*#__PURE__*/_react["default"].createElement(_rmcDatePicker["default"], {
    minDate: minDate,
    maxDate: maxDate,
    defaultDate: new Date(),
    formatMonth: function formatMonth(month) {
      return (0, _dateFns.format)((0, _dateFns.setMonth)(new Date(), month), 'MMM');
    },
    mode: getMode(dateFormat)
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Input, {
    value: date && formatDisplay(date),
    placeholder: placeholder,
    onClick: function onClick() {
      return setOpen(true);
    },
    readOnly: true,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_Popup["default"], {
    visible: open,
    datePicker: datePicker,
    transitionName: "rmc-picker-popup-slide-fade",
    maskTransitionName: "rmc-picker-popup-fade",
    date: date,
    okText: "Confirm",
    dismissText: "Cancel",
    onDismiss: function onDismiss() {
      return setOpen(false);
    },
    onChange: function onChange(date) {
      setDate(date);
      _onChange(formatSubmit(date));
      setOpen(false);
    }
  }));
};
DOB.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  formatDisplay: _propTypes["default"].func.isRequired,
  formatSubmit: _propTypes["default"].func.isRequired,
  dateFormat: _propTypes["default"].oneOf(['YYYY-MM-DD', 'MM-DD-YYYY', 'YYYY-MM', 'YYYY'])
};
DOB.defaultProps = {
  minDate: new Date('1901'),
  dateFormat: 'YYYY-MM-DD'
};
var _default = exports["default"] = DOB;